/**
 * Wordmark — minimal bow glyph + "BOW & ARROW" uppercase label.
 * Pure presentational; no state, no Effects.
 */
import type { Strings } from "../strings";

export interface WordmarkProps {
  strings: Strings;
}

export function BowSigil(props: { className?: string }): JSX.Element {
  // Minimal geometric bow: arc + string + nocked arrow, drawn east-facing so
  // the arrow points right — aligned with the "released forward" metaphor and
  // the rightward Aimed Shot animation (Task 072). Bow on the left, arrow tip
  // at x=20.
  const className = props.className ?? "wordmark__glyph";
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M5 3 C 15 7, 15 17, 5 21"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <line
        x1="5"
        y1="3"
        x2="5"
        y2="21"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        opacity="0.55"
      />
      <line
        x1="5"
        y1="12"
        x2="20"
        y2="12"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M20 12 L16.5 9.6 M20 12 L16.5 14.4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Wordmark(props: WordmarkProps): JSX.Element {
  const { strings } = props;
  return (
    <div className="wordmark">
      <BowSigil />
      <span className="wordmark__name">{strings.appTitle}</span>
      <img
        className="wordmark__logo"
        src="/los-del-camino.png"
        alt="Los del Camino"
        width={170}
        height={56}
      />
    </div>
  );
}
